import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { Capacitor } from '@capacitor/core';
import { Keyboard } from '@capacitor/keyboard';
import { AppPlatformService } from '../platform/app-platform.service';

@Injectable({
  providedIn: 'root'
})
export class KeyboardService {
  private keyboardStatusSubject = new BehaviorSubject<boolean>(true); // true = hidden
  private listenersInitialized = false;

  constructor(private appPlatformService:AppPlatformService,) {
    this.initializeKeyboardListeners();
  }

  // Observable para que los componentes se suscriban
  get keyboardStatus$(): Observable<boolean> {
    return this.keyboardStatusSubject.asObservable();
  }

  // Getter para obtener el estado actual
  get isKeyboardHidden(): boolean {
    return this.keyboardStatusSubject.value;
  }

  private initializeKeyboardListeners(): void {
    if (!this.appPlatformService.isAppPlatform() || this.listenersInitialized) {
      return;
    }

    Keyboard.addListener('keyboardDidHide', () => {
      this.keyboardStatusSubject.next(true);
    });

    Keyboard.addListener('keyboardWillShow', (info) => {
      this.keyboardStatusSubject.next(false);
    });

    this.listenersInitialized = true;
  }

  // Método para limpiar listeners si es necesario
  removeListeners(): void {
    if (this.appPlatformService.isAppPlatform()) {
      Keyboard.removeAllListeners();
      this.listenersInitialized = false;
    }
  }

}
